module.exports = __webpack_public_path__ + "static/media/bookbank.277d3a2c.png";